import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const NewFieldAddContainer = styled.div`
  width: 273px;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: 4px;
  padding: 12px;
  div.field-card.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    :hover {
      cursor: not-allowed;
    }
  }
  div.field-card {
    height: 54px;
    place-content: center;
    overflow: hidden;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 6px 0;
    :hover {
      cursor: pointer;
      background: #e5ecff;
    }
    svg {
      flex: 1;
    }
    div.field-name {
      height: 24px;
      font-weight: 400;
      font-size: 12px;
      line-height: 13px;
      color: #12344d;
    }
  }
`;

export const CustomFieldForm = styled.form`
  width: 100%;
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const CustomFieldDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ChoicesOverflow = styled.div`
  background: #12344d;
  border-radius: 4px;
  margin-left: 4px;
  height: 200px;
  overflow-y: scroll;
  padding: 4px 8px;
  & > :not(:last-child) {
    margin-bottom: 8px;
  }
  div.choice {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
    max-width: 256px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ChoicesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ChoiceCard = styled.div`
  ${ChipStyleMixin}
  background: #ebeff3;
  border-radius: 4px;
  font-weight: 600;
  color: #384551;
  white-space: nowrap;
  max-width: 296px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 8px 8px 0;
  &.pointer {
    cursor: pointer;
    overflow: auto;
  }
`;

export const CustomFieldMeta = styled.div`
  padding: 4px 0;
  display: flex;
  align-items: center;
  min-height: 32px;
  font-weight: 500;
  font-size: 16px;
  color: #12344d;
  display: flex;
  align-items: center;
  flex: 1;
  overflow: auto;
  .field-label {
    white-space: nowrap;
    max-width: 296px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .required {
    color: var(--text-danger);
    padding-left: 4px;
  }
  .default {
    ${ChipStyleMixin}
    background: #ebeff3;
    border-radius: 4px;
    font-weight: 600;
    color: #384551;
  }
  .field-copy {
    display: grid;
    background: #f2f2f2;
    border-radius: 2px;
    cursor: pointer;
    height: 20px;
    width: 20px;
    place-content: center;
    margin-right: 16px;
  }
  .field-name {
    font-family: Courier New;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 30px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .spacer {
    flex: 1;
  }
  input[name='label'] {
    width: 200px;
  }
  .label-text {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #475867;
    margin-right: 8px;
  }
  & > * {
    margin-right: 16px;
  }
`;

export const DropDownFieldForm = styled.div`
  padding: 16px;
  .wrapper-div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .description {
      margin-left: 8px;
      font-size: 14px;
    }
  }
  .reorder-choices {
    padding: 4px 0;
    max-height: 256px;
    overflow: auto;
  }
  .divider {
    border-right: 1px solid #ececec;
    width: 1px;
    height: 24px;
  }
  .button-actions {
    display: flex;
    align-items: center;
    & > :not(:last-child) {
      margin-right: 16px;
    }
    &.disabled {
      opacity: 0.4;
      .add {
        cursor: not-allowed;
      }
    }
  }
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const CustomFieldFormActions = styled.div`
  /* border-top: 1px solid #d3d3d3; */
  padding-top: 16px;
  display: flex;
`;

export const CustomFieldListItem = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 9px rgba(22, 29, 37, 0.1);
  border-radius: 6px;
  min-height: 60px;
  padding: 16px;
  width: 100%;
  :hover {
    .field-actions.hide {
      display: flex;
    }
    .field-copy.hide {
      display: grid;
    }
  }
  .field-actions.hide {
    display: none;
  }
  .field-copy.hide {
    display: none;
  }
  .field-actions {
    display: flex;
    align-items: center;

    & > :not(:last-child) {
      margin-right: 16px;
    }
    button.dropdown-button {
      min-height: 28px;
    }
    button {
      display: flex;
      align-items: center;
      margin: 0;
      svg {
        margin-right: 8px;
      }
    }
  }
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const CustomFieldList = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin || '0'};
  padding: 0;
`;

export const FieldChoice = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #434a50;
  width: fit-content;
  div.remove {
    cursor: pointer;
  }
  &.add {
    cursor: pointer;
  }
  & > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const BulkAddChoices = styled.form`
  padding: 24px;
  text-align: left;
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
  div.choice-head {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #12344d;
  }
  div.choice-desc {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #7a8997;
  }
  div.choice-actions {
    display: flex;
    div.spacer {
      flex: 1;
    }
  }
  div.multi-line {
    height: 150px;
  }
`;
